import { authFetch } from "./authApi";

async function parseError(response, fallback) {
  const body = await response.text().catch(() => "");
  throw new Error(body || fallback || response.statusText || "Attachment request failed");
}

export async function uploadAttachment(file) {
  const formData = new FormData();
  formData.append("file", file);

  const response = await authFetch("/attachments/upload", {
    method: "POST",
    body: formData,
  });

  if (!response.ok) {
    return parseError(response, "Attachment upload failed");
  }

  return response.json();
}

export async function deleteAttachment(storagePath) {
  const response = await authFetch("/attachments/delete", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ storage_path: storagePath }),
  });

  if (!response.ok) {
    return parseError(response, "Attachment delete failed");
  }

  return response.json();
}

export async function downloadAttachment(item) {
  const storagePath = encodeURIComponent(String(item?.storage_path || ""));
  const response = await authFetch(`/attachments/download?storage_path=${storagePath}`, {
    method: "GET",
  });

  if (!response.ok) {
    return parseError(response, "Attachment download failed");
  }

  const blob = await response.blob();
  const downloadUrl = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = downloadUrl;
  anchor.download = String(item?.file_name || item?.label || "attachment");
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(downloadUrl);
}